import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DocumentPanel from '../components/DocumentPanel';

function DocumentWorkspace({ companyId }) {
  const { objectType, objectId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const withFallback = (key, fallback) => {
    const value = t(key);
    return !value || value === key ? fallback : value;
  };

  const parsedId = Number(objectId);

  return (
    <div className="container-fluid py-3 doc-workspace">
      <div className="doc-workspace-header mb-3">
        <div>
          <p className="doc-panel-eyebrow mb-1">{withFallback('documents.title', 'Documentación')}</p>
          <h2 className="mb-1">{withFallback('documents.fullscreen_title', 'Documentación a pantalla completa')}</h2>
          <p className="text-muted mb-0">{withFallback('documents.fullscreen_subtitle', 'Trabaja cómodo con filtros, historial y editor ancho.')}</p>
        </div>
        <div className="d-flex gap-2">
          <button className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
            {withFallback('action.close', 'Cerrar')}
          </button>
        </div>
      </div>

      <DocumentPanel
        objectType={objectType}
        objectId={Number.isNaN(parsedId) ? objectId : parsedId}
        companyId={companyId}
        variant="fullpage"
        isOpen
        anchorTitle={withFallback('documents.title', 'Documentación')}
      />
    </div>
  );
}

export default DocumentWorkspace;
